module.exports = __webpack_public_path__ + "static/gallery-img-3-ddf52c133c28758eb08e229946923ba3.jpg";